module.exports = __webpack_public_path__ + "img/book-icon.301e8cd4.svg";